import { render, staticRenderFns } from "./EventOC.vue?vue&type=template&id=0bb2a8ca&scoped=true"
import script from "./EventOC.vue?vue&type=script&lang=js"
export * from "./EventOC.vue?vue&type=script&lang=js"
import style0 from "./EventOC.vue?vue&type=style&index=0&id=0bb2a8ca&prod&lang=scss&scoped=true"
import style1 from "./EventOC.vue?vue&type=style&index=1&id=0bb2a8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2a8ca",
  null
  
)

export default component.exports